// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};



	// ProductListNoSearchResult.prototype.compileTitleTemplate = function() {

	// 	console.log(232234)
	// 	var settings = Settings.getSettingValue('search.suggestionNoResult');

	// 	// Get title label
	// 	var titleLabel = Labels.suggestion.noSearchResultProductsLabel;

	// 	// Get result empty label from app admin and not from theme
	// 	var emptyLabel = Labels.search.resultEmpty;
	// 	var currentLocale = Settings.getSettingValue('general.current_locale');
	// 	var translatedLabel = Settings.getSettingValue('labelTranslations.' + currentLocale + '.search.resultEmpty');
	// 	if (translatedLabel) {
	// 		emptyLabel = translatedLabel;
	// 	}

	// 	// Build no result search tips template
	// 	var tips = '';
	// 	if (Settings.getSettingValue('search.searchPanelBlocks.searchTips.active')) {
	// 		var tipsContent = Labels.search.searchTipsContent.split('{{ breakline }}');

	// 		var searchTipsListItem = '';
	// 		for (var i = 0; i < tipsContent.length; i++) {
	// 			if(tipsContent[i] != ''){
	// 			searchTipsListItem += `<li>${tipsContent[i]}</li>`;
	// 			}
	// 		}
	// 		tips = this.getNoResultSearchTipsTemplate()
	// 			.replace(/{{searchTipsTitle}}/g, Labels.search.searchTipsTitle)
	// 			.replace(/{{searchTipsListItem}}/g, searchTipsListItem);
	// 	}

	// 	// Build no result search suggestion template
	// 	var suggestionList = '';

	// 	if (Settings.getSettingValue('search.searchPanelBlocks.searchTermSuggestions.active')) {
	// 		var suggestionBlocks = Settings.getSettingValue('search.suggestionNoResult.search_terms.data');
	// 		for (var i = 0; i < suggestionBlocks.length; i++) {
	// 			suggestionList += `
	// 				<li>
	// 					<a href="/search?q=${Utils.encodeURIParamValue(suggestionBlocks[i])}">${suggestionBlocks[i]}</a>
	// 				</li>
	// 			`.trim();
	// 		}
	// 		if(suggestionBlocks.length > 0){
	// 			suggestionList = this.getNoResultSearchSuggestionsTemplate()
	// 				.replace(/{{searchTermSuggestionTitle}}/g, Labels.suggestion.noSearchResultSearchTermLabel)
	// 				.replace(/{{searchTermSuggestionListItem}}/g, suggestionList);
	// 		}
	// 	}

	// 	// Build most popular template
	// 	var noResultSearchMostPopularTemplate = '';
	// 	if (Settings.getSettingValue('search.searchPanelBlocks.mostPopularProducts.active') && this.data.length > 0) {
	// 		noResultSearchMostPopularTemplate = this.getNoResultSearchMostPopular();
	// 	}

	// 	// Build title template
	// 	return this.getTitleTemplate()
	// 		.replace(/{{noResultSearchTipsTemplate}}/g, tips)
	// 		.replace(/{{noResultSearchSuggestionTemplate}}/g, suggestionList)
	// 		.replace(/{{noResultSearchMostPopular}}/g, noResultSearchMostPopularTemplate)
	// 		.replace(/{{noSearchResultTitle}}/g, titleLabel)
	// 		.replace(/{{label.resultEmpty}}/g, emptyLabel)
	// 		.replace(/{{ terms }}/g, '<b>' + Utils.stripHtml(Globals.queryParams.q) + '</b>')
	// 		.replace(/{{ breakline }}/g, '<br />');
	// }
})();